import { create } from 'zustand'

const clamp01 = (x) => Math.max(0, Math.min(1, x))

export const useActsStore = create((set, get) => ({
  actsProgress: {},

  setActProgress: (id, data) =>
    set((state) => ({
      actsProgress: { ...state.actsProgress, [id]: data },
    })),

  getCurrentActId: () => {
    const ap = get().actsProgress
    let bestId = null
    let bestScore = -Infinity
    for (const [idStr, v] of Object.entries(ap)) {
      if (!v) continue

      const phaseScore =
        v.phase === 'hold'
          ? 20
          : v.phase === 'transition'
            ? 10
            : 0

      const prog =
        v.phase === 'transition'
          ? (v.phaseProgress ?? 0)
          : (v.holdProgress ?? 0)

      const score = (v.isVisible ? 100 : 0) + phaseScore + prog

      if (score > bestScore) {
        bestScore = score
        bestId = +idStr
      }
    }
    return bestId
  },

  /**
   * Progress global d'un acte [0,1] réparti en 3 zones :
   *   [0,               transitionPart]       = transition entrante (depuis acte-1)
   *   [transitionPart,  1 - transitionPart]   = hold
   *   [1 - transitionPart, 1]                 = transition sortante (vers acte+1)
   */
  getActGlobalProgress: (id, transitionPart = 0.2) => {
    const ap = get().actsProgress
    const act = ap[id]
    const prev = ap[id - 1]

    const holdStart = transitionPart
    const holdEnd = 1 - transitionPart
    const holdSpan = holdEnd - holdStart

    // 1) Acte en transition SORTANTE (vers id+1)
    if (act?.phase === 'transition' && act?.transitionKind === 'exit') {
      const t = clamp01(act.phaseProgress ?? 0)
      return holdEnd + t * transitionPart
    }

    // 2) Acte en phase hold
    if (act?.phase === 'hold') {
      const h = clamp01(act.holdProgress ?? 0)
      return holdStart + h * holdSpan
    }

    // 3) Transition ENTRANTE : l'acte précédent est en phase transition (exit),
    //    ou cet acte est lui-même en phase transition (enter, géré dans ton Orchestreur).
    if (act?.phase === 'transition' && act?.transitionKind === 'enter') {
      const t = clamp01(act.phaseProgress ?? 0)
      return t * transitionPart
    }

    // Fallback (historique) : on se base sur prev si dispo
    const t = clamp01(prev?.phaseProgress ?? 0)
    return t * transitionPart
  },
}))